import { MapGrouping } from './map-grouping';
import { InspectFieldObject } from '../objects/inspect-field-object';
import { Pose } from '../../models/pose';
import { ApiModel } from '../../models/api-model';
import { HasPose } from '../../models/interfaces/has-pose';
import { GroupEventType, MapGroupingEvent } from './map-grouping-event';
import { MapObject } from '../objects/map-object';
import { Layers } from './map-layer';
import { RobotModel } from '../../models/robot-model';

@Layers([
  { name: 'cameraFields', zIndex: 10 }
])
export class InspectFieldGrouping extends MapGrouping<Pose, InspectFieldObject> {
  private robotModel: RobotModel;

  constructor(public poseGrouping: MapGrouping<ApiModel & HasPose, MapObject>, options = {}) {
    super(options);
    poseGrouping.changed().subscribe(() => this.redraw());
  }

  createObject(data: Pose): InspectFieldObject {
    return new InspectFieldObject(data, this.storeMap, this.robotModel);
  }

  private redraw() {
    this.clearEntries();
    this.storeMap = this.storeMap || this.poseGrouping.storeMap;

    for (const entry of this.poseGrouping.entries) {
      const fieldEntry = this.processData(entry.data.pose);
      if (fieldEntry) {
        fieldEntry.object.getFabric().on('moving', () => {
          fieldEntry.object.update(entry.data.pose);
        });

        fieldEntry.object.getFabric().on('rotating', () => {
          fieldEntry.object.update(entry.data.pose);
        });

        // Change opacity when selected
        fieldEntry.object.getFabric().on('selected', () => {
            fieldEntry.object.select();
          }
        );
        fieldEntry.object.getFabric().on('deselected', () => {
          fieldEntry.object.deselect();
        });

        this.eventSource.next(new MapGroupingEvent(GroupEventType.added, fieldEntry));
      }
    }

    this.eventSource.next(new MapGroupingEvent(GroupEventType.changed));
  }

  public setRobotModel(robotModel: RobotModel) {
    this.robotModel = robotModel;
    this.redraw();
  }
}
